var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error401"},[_c('p',[_vm._v("401")]),_c('p',[_vm._v("么有权限访问哦~")])])}]

export { render, staticRenderFns }